import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, publishReplay, refCount } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { AppConfig, AppConfigService } from "src/services/app-config.service";
import { AuthService } from "src/auth/auth.service";
import { environment } from "src/environments/environment";

@Injectable()
export class OrgSettingsData {
  private readonly _appConfig: AppConfig = new AppConfig();
  private _doctors: Observable<any>;
  private _docrorsLastUrl: string;
  private _centers: Observable<any>;

  private static instance: OrgSettingsData = null;

  private constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService) {

    this._appConfig = this.appConfigService.getConfig();
    if (environment.debug_mode) {
      console.log(
        "OrgSettingsService, oc_api_url: " + this._appConfig.oc_api_url
      );
    }
  }

  public static getInstance( httpClient: HttpClient,   appConfigService: AppConfigService): OrgSettingsData {
    if (OrgSettingsData.instance == null) {
      OrgSettingsData.instance = new OrgSettingsData(
        httpClient,
        appConfigService
      );
    }
    return OrgSettingsData.instance;
  }

  //-----------------------------------------------------------
  //get Doctors - begin
  //-----------------------------------------------------------
  getDoctors(centerId: string): Observable<any> {
    let url: string = "";

    url =
      this._appConfig.oc_api_url +
      environment.oc_api_members_url +
      "doctors?centerId=" +
      centerId;

    if (!this._doctors || this._docrorsLastUrl !== url) {
      this._docrorsLastUrl = url;

      if (environment.debug_mode) {
        console.log("getDoctors: " + url);
      }

      this._doctors = this.http.get(url).pipe(
        map((data) => data),
        publishReplay(1),
        refCount()
      );
    }

    return this._doctors;
  }

  clearDoctors() {
    this._doctors = undefined;
  }
  //-----------------------------------------------------------
  //get Doctors - end
  //-----------------------------------------------------------

  //-----------------------------------------------------------
  // Get Org Centers - begin
  //-----------------------------------------------------------
  getCenters(pageLimit: number): Observable<any> {
    
    if (!this._centers) {
      const url: string =
        this._appConfig.oc_api_url +
        environment.oc_api_centers_url +
        "?pageLimit=" +
        pageLimit;

      if (environment.debug_mode) {
        console.log("getOrgCenters url: " + url);
      }

      this._centers = this.http.get(url).pipe(
        map((data) => data),
        publishReplay(1),
        refCount()
      );
    }

    return this._centers;
  }

  clearCenters() {
    this._centers = null;
  }
  //-----------------------------------------------------------
  // Get Org Centers - end
  //-----------------------------------------------------------
}
